<template>
  <div>
    <CompanyListTemplate/>
    <HeaderTemplate/>
    <slot/>
    <FooterTemplate/>
  </div>
</template>

<script>
import i18n from '@/i18n'
import CompanyListTemplate from './CompanyListTemplate.vue'
import HeaderTemplate from './HeaderTemplate.vue'
import FooterTemplate from './FooterTemplate.vue'

export default {
  name: 'main-template',
  components: {
    CompanyListTemplate,
    HeaderTemplate,
    FooterTemplate
  },
  methods: {
    changeLang: function (lang) {
      i18n.locale = lang
    }
  }
}
</script>
